import { Model, Attr, BelongsTo, HasOne } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';
import User from '../auth/User';
import FaunaMedia from './FaunaMedia';
import FaunaTag from './FaunaTag';
import DetectionBbox from './DetectionBbox';

export enum DiseaseStatus {
  healthy = 'healthy',
  diseased = 'diseased',
  unsure = 'unsure',
}

export enum ConfidenceLevel {
  // eslint-disable-next-line @typescript-eslint/camelcase
  very_low = 0,
  low = 1,
  medium = 2,
  high = 3,
  // eslint-disable-next-line @typescript-eslint/camelcase
  very_high = 4,
}

export enum TaggerType {
  user = 'user',
  ai = 'ai',
  expert = 'expert',
}

// none -> user hasnt chosen a tag
// conflict -> user has a different tag than the ai
// agreed -> user has chosen the ai tag
// resolved -> expert has decided on a tag
export enum TagStatusType {
  none = 'none',
  conflict = 'conflict',
  agreed = 'agreed',
  resolved = 'resolved',
}

@Model()
export default class FaunaMediaTag extends ApplicationRecord {
  static jsonapiType = 'fauna-media-tags';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
    ];
  }

  static scopeFactory() {
    return FaunaMediaTag.includes([]);
  }

  @Attr() readonly createdAt: string;

  // whether or not this is the resolved tag of a bbox
  @Attr() readonly isFinal: string;

  // TODO: re-implement this
  @Attr() diseaseStatus: DiseaseStatus;

  // user / ai provides this
  // TODO: how does a user set this?
  // TODO: migrate this to float 0-1 to keep up with the AI confidence data
  @Attr() confidenceLevel: ConfidenceLevel;

  @Attr() readonly taggerType: TaggerType;

  @BelongsTo() readonly createdBy: User;

  @BelongsTo() readonly faunaMedia: FaunaMedia; // will be deprecated

  @BelongsTo() detectionBbox: DetectionBbox;

  @HasOne() faunaTag: FaunaTag;

  get diseaseStatusText() {
    switch (this.diseaseStatus) {
      case DiseaseStatus.healthy:
        return '(Healthy)';
      case DiseaseStatus.diseased:
        return '(Diseased)';
      case DiseaseStatus.unsure:
        return '(Disease unsure)';
      default:
        return '';
    }
  }

  get confidenceText() {
    switch (this.confidenceLevel) {
      case ConfidenceLevel.very_low:
        return 'Very Low';
      case ConfidenceLevel.low:
        return 'Low';
      case ConfidenceLevel.medium:
        return 'Medium';
      case ConfidenceLevel.high:
        return 'High';
      case ConfidenceLevel.very_high:
        return 'Very High';
      default:
        return 'Unknown';
    }
  }

  get confidenceIcon() {
    switch (this.confidenceLevel) {
      case ConfidenceLevel.very_low:
        return 'mdi-circle-outline';
      case ConfidenceLevel.low:
        return 'mdi-circle-slice-2';
      case ConfidenceLevel.medium:
        return 'mdi-circle-slice-4';
      case ConfidenceLevel.high:
        return 'mdi-circle-slice-6';
      case ConfidenceLevel.very_high:
        return 'mdi-circle-slice-8';
      default:
        return '';
    }
  }
}
